// Canonical, SEO-friendly listing URLs.
//
//   /<type>/<category>/<subcategory>/<slug>
//
// The trailing `slug` (which embeds a short id suffix) is what resolves the
// listing on the backend. The category/subcategory segments are cosmetic SEO
// context and are safe to change. Falls back to the raw id for legacy rows
// with no stored slug.

const TYPE_PATH = { sell: 'sell', wanted: 'wanted', rent: 'rent', service: 'services' };

const seg = (s) => {
  if (!s) return null;
  const out = String(s)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return out || null;
};

export function listingPath(listing) {
  if (!listing) return '/';
  const typePath = TYPE_PATH[listing.listing_type] || 'sell';
  const parts = [typePath];
  // Prefer the STABLE taxonomy path_slug (single source of truth). Fall back to
  // the human name only for legacy rows not yet backfilled.
  const cat = seg(listing.category_path_slug || listing.category_name || listing.category_slug);
  const sub = seg(listing.subcategory_path_slug || listing.subcategory_name || listing.subcategory_slug);
  if (cat) parts.push(cat);
  if (sub) parts.push(sub);
  parts.push(listing.slug || listing.id);
  return '/' + parts.join('/');
}

export default listingPath;
